<template>
  <el-dialog :visible="modifyPwdVisible"  :append-to-body="true" class="modify-password-dialog" width="600px"
    @open="onOpen" @close="onClose" :destroy-on-close="true">
    <div slot="title">
      <i class="edit-icon el-icon-edit"></i>
      <span>修改密码</span>
    </div>
    <el-form ref="pwdForm" class="passwordForm"  :rules="rules" :model="passWordForm">
        <el-form-item prop="resetPassWord">
          <template #label>
            <div class="customLabel">
              <div>新密码</div>
            </div>
          </template>
          <el-input
            v-model.trim="passWordForm.resetPassWord"
            placeholder="请输入密码"
            autocomplete="off"
            maxlength="32"
            :type="showPassword?'password':'text'"/>
            <span class="show-pwd" @click="showPassword = !showPassword">
              <i v-if="showPassword" class="QS-icon-view-close" />
              <i v-else class="QS-icon-view" />
            </span>
        </el-form-item>
        <el-form-item prop="resetPassWordConfirm">
          <template #label>
              <div class="customLabel">
                <div>确认新密码</div>
              </div>
          </template>
          <el-input
            v-model.trim="passWordForm.resetPassWordConfirm"
            placeholder="请输入密码"
            autocomplete="off"
            maxlength="32"
            :type="showPasswordConfirm?'password':'text'"
          />
            <span class="show-pwd" @click="showPasswordConfirm = !showPasswordConfirm">
              <i v-if="showPasswordConfirm" class="QS-icon-view-close" />
              <i v-else class="QS-icon-view" />
            </span>
        </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="onClose">取消</el-button>
      <el-button type="primary" @click="onConfirm" :loading="oLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { validatePwd, pwdErrInfo } from '@/utils/passwordValidate'
import {
  setPassword,
} from '@/api/domain/organize'


export default {
  components: {
  },
  props: {
    modifyPwdVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      passWordForm: {
        resetPassWord: '',
        resetPassWordConfirm: '',
      },
      showPassword: true,
      showPasswordConfirm: true,
      oLoading: false,
      rules: {
        resetPassWord: [
          { required: true, message: '请输入密码', trigger: 'change' },
          { validator: validatePwd, message: pwdErrInfo, trigger: 'change' },
        ],
        resetPassWordConfirm: [
          { required: true, message: '请输入密码', trigger: 'change' },
          { validator: this.validateConfirmPwd, trigger: 'change' },
        ],
      },
    }
  },
  computed: {
    // eslint-disable-next-line vue/no-unused-properties
    ...mapGetters(['userInfo']),
  },
  methods: {
    validateConfirmPwd(rule, value, callback) {
      if (value !== this.passWordForm.resetPassWord) {
        return callback(new Error('两次输入密码不一致!'))
      }
      if (validatePwd(rule, value, callback)) {
        callback(new Error(pwdErrInfo))
      }
    },
    // eslint-disable-next-line vue/no-unused-properties
    onCopy() {
      this.$message.success('复制成功')
    },
    onOpen() {
      this.passWordForm.resetPassWord = ''
    },
    onClose() {
      this.passWordForm.resetPassWord = ''
      this.passWordForm.resetPassWordConfirm = ''
      this.$emit('updateVisible', false)
    },
    async onConfirm() {
      this.$refs.pwdForm?.validate(async (valid) => {
        this.oLoading = true
        if (valid) {
          const params = {
            id: this.$store.getters.userInfo.id,
            password: this.passWordForm.resetPassWord,
          }
          const { code } = await setPassword(params)
          if (code === 1) {
            this.onClose()
            this.$message.success('操作成功')
          }
        }
        this.oLoading = false
      })
    },
  },
}
</script>
<style lang="scss" scoped>
$light_gray: rgba(0, 0, 0, 0.7);
$dark_gray: #889aa4;

.passwordForm {
  ::v-deep .el-form-item {
    color: #C8C9CC;
    border-radius: 2px;

    .el-form-item__content {
      display: block;
    }

    .el-form-item__error {
      padding-top: 4px;
      color: #EA0000;
    }

    .show-pwd {
      font-size: 16px;
      color: $dark_gray;
      cursor: pointer;
      user-select: none;
      position: absolute;
      right: -5px;
      bottom: -7px;
    }

    .captcha-btn,
    .show-pwd {
      line-height: 45px;
      float: right;
      padding: 0;
      padding-right: 16px;
    }
  }
}

.edit-icon {
  margin-right: 6px;
}

.customLabel {
  width: 100%;
  display: block;
  margin-bottom: 10px;
  justify-content: space-between;
}
</style>
